<div class="nvme-now-card-plugin" hive-root>
    <div class="nvme-now-card-plugin__deal-badge">
        <svg [hive-svg]="'discount-tag.svg'" [height]="54"></svg>
    </div>
    <div class="nvme-now-card-plugin__message">
        Upgrade to NVMe to achieve better performance with the latest in storage technology
    </div>
    <div class="nvme-now-card-plugin__trade-up-icon">
        <svg [hive-svg]="'lean-trade-up.svg'" [height]="40"></svg>
    </div>
    <div class="nvme-now-card-plugin__call-to-action">
        Plan upgrade from SAS to <span class="text-green bold">NVMe</span> with your Everpure account team
    </div>
</div>
